import Vue from "vue";
import VueMeta from "vue-meta";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import filters from "@plugins/filters";
import vuetify from "@plugins/vuetify";
import GoogleMaps from "@plugins/googleMaps";
import snackBarPlugin from "@plugins/snackbar";
import { init } from "@services";
import VueClipboard from "vue-clipboard2";

Vue.config.productionTip = false;

Vue.use(snackBarPlugin, { store });
Vue.use(filters);
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true,
});

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
    beforeCreate() {
        store.commit("api/apiURL", process.env.VUE_APP_SAFETY_API_URL || window.appConfig?.VUE_APP_SAFETY_API_URL);
        store.commit("api/userAppUrl", process.env.VUE_APP_APP_URL || window.appConfig?.VUE_APP_APP_URL);
        store.commit("api/portalUrl", process.env.VUE_APP_PORTAL_URL || window.appConfig?.VUE_APP_PORTAL_URL);
        store.commit(
            "api/googleMapsApiKey",
            process.env.VUE_APP_GOOGLE_MAPS_API_KEY || window.appConfig?.VUE_APP_GOOGLE_MAPS_API_KEY,
        );
        store.commit(
            "api/helpCenterUrl",
            process.env.VUE_APP_HELP_CENTER_URL || window.appConfig?.VUE_APP_HELP_CENTER_URL,
        );
        store.commit("api/chatBotUrl", process.env.VUE_APP_CHAT_BOT_URL || window.appConfig?.VUE_APP_CHAT_BOT_URL);

        // baked by build system
        store.commit("settings/version", process.env.VUE_APP_VERSION);

        store.commit("api/apiKey", "obsolete");

        init();
    },
    created() {
        Vue.use(GoogleMaps, this.$store);
    },
}).$mount("#app");
